import {Inject, Injectable, InjectionToken} from '@angular/core';
import * as Raven from 'raven-js';
import {Breadcrumb, RavenOptions} from 'raven-js';
import {buildInfo} from 'src/environments/buildInfo';
import {getEnvName} from 'src/environments/env-name';
import {SentryParams} from 'src/environments/envirounmet.interface';

export const SentryConfig = new InjectionToken('SentryConfig');

@Injectable()
export class Sentry {
    constructor(@Inject(SentryConfig) config: SentryParams) {
        const options: RavenOptions = {
            ...config.options,
            ...{
                maxUrlLength: 0,
                extra: {buildInfo},
                serverName: document.location.host,
                release: buildInfo.version,
                environment: getEnvName(),
            },
        };
        Raven.config(config.dsn, options).install();
    }

    setUserContext(user: any) {
        Raven.setUserContext(user);
    }

    sendMessage(msg: string) {
        Raven.captureMessage(msg);
    }

    handleError(err: any): void {
        Raven.captureException(err, err.options);
    }

    leaveBreadCrumbs(crumb: Breadcrumb) {
        console.debug(`[${crumb.category}] ${crumb.message}`);
        Raven.captureBreadcrumb(crumb);
    }
}

@Injectable()
export class DummySentry {
    /* istanbul ignore next */
    handleError(err) {
        console.log('As if reported to sentry: ', err);
    }

    /* istanbul ignore next */
    setUserContext(user: any) {
        console.log(user);
    }

    sendMessage(msg: string) {
        console.log(`[Sentry] ${msg}`);
    }

    /* istanbul ignore next */
    leaveBreadCrumbs(crumb: Breadcrumb) {
        console.log(`[${crumb.category}] ${crumb.message}`);
    }
}

@Injectable()
export class MuteSentry {
    /* istanbul ignore next */
    handleError(err) {}

    /* istanbul ignore next */
    setUserContext(user: any) {}

    /* istanbul ignore next */
    leaveBreadCrumbs() {}
}
